export default langsData => [
    {
      path: "/pays_h5",
      name: "pays_h5",
      component: () =>
        import(/* webpackChunkName: "login_h5" */ "@/views/paygames/h5/index.vue"),
      baseWidth: "360",
      meta: {
        title: langsData["paygame"].title,
      },
    },
    {
      path: "/pays_h5/pg_record",
      name: "pays_h5Pgrecord",
      component: () =>
        import(
          /* webpackChunkName: "login_h5" */ "@/views/paygames/h5/pgrecord.vue"
        ),
      baseWidth: "360",
      meta: {
        title: langsData["paygame"].title,
        needLogin: true
      },
    },
    {
      path: "/pays_h5/setoutpay",
      name: "pays_h5Setoutpay",
      component: () =>
        import(
          /* webpackChunkName: "login_h5" */ "@/views/paygames/h5/setoutpay.vue"
        ),
      baseWidth: "360",
      meta: {
        title: langsData["paygame"].title,
        needLogin: true
      },
    },
    {
      path: "/pays_h5/payorder",
      name: "pays_h5Payorder",
      component: () =>
        import(
          /* webpackChunkName: "login_h5" */ "@/views/paygames/h5/payorder.vue"
        ),
      baseWidth: "360",
      meta: {
        title: langsData["paygame"].title,
        needLogin: true
      },
    },
    {
      path: "/pays_h5/paycomplete",
      name: "pays_h5Paycomplete",
      component: () =>
        import(
          /* webpackChunkName: "login_h5" */ "@/views/paygames/h5/paycomplete.vue"
        ),
      baseWidth: "360",
      meta: {
        title: langsData["paygame"].title,
        needLogin: true
      },
    },
    {
      path: "/pays_h5/paysucceed",
      name: "pays_h5Paysucceed",
      component: () =>
        import(
          /* webpackChunkName: "login_h5" */ "@/views/paygames/h5/paysucceed.vue"
        ),
      baseWidth: "360",
      meta: {
        title: langsData["paygame"].title,
        needLogin: true
      },
    },
    {
      path: "/pays_h5/payaffirm",
      name: "pays_h5Payaffirm",
      component: () =>
        import(
          /* webpackChunkName: "login_h5" */ "@/views/paygames/h5/payaffirm.vue"
        ),
      baseWidth: "360",
      meta: {
        title: langsData["paygame"].title,
        needLogin: true
      },
    },
  ];
  